var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("div", { staticClass: "overlay clear w-100 h-100" })
        : _vm._e(),
      _vm._v(" "),
      _c("v-client-table", {
        staticClass: "card table-clients vue-custom-table mb-0",
        attrs: {
          id: "referrersTableId",
          data: _vm.referrers,
          columns: _vm.tableColumns,
          options: _vm.options,
        },
        scopedSlots: _vm._u([
          {
            key: "fullName",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  { staticClass: "d-inline-flex" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-none d-md-block" },
                      [
                        _c(
                          "profile-avatar",
                          _vm._b(
                            { staticClass: "client-avatar mr-2" },
                            "profile-avatar",
                            row,
                            false
                          )
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "regular my-auto text-primary text-capitalize bold",
                        attrs: { to: _vm.referrerDetailsLink(row) },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.givenName) +
                            " " +
                            _vm._s(row.familyName) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "email",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v("\n        " + _vm._s(row.email) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "phoneNumber",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v("\n        " + _vm._s(row.phoneNumber) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "referralCode",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v("\n        " + _vm._s(row.referralCode) + "\n      "),
                ]),
              ]
            },
          },
          {
            key: "type",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("referrers.referrerType." + row.type)) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "value",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatMoneyValue")(_vm.getCombined(row))) +
                      "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "actionbuttons",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "b-row",
                  { attrs: { "align-v": "center", "no-gutters": "" } },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "btn bold btn-white btn-sm d-xl-inline d-none",
                        attrs: { to: _vm.referrerDetailsLink(row) },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("referrers.actions.viewReferrer")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.topValues[row.id] >= 0
                      ? _c("referrer-trophy", {
                          staticClass: "ml-3",
                          attrs: {
                            position: _vm.topValues[row.id],
                            "combined-value": _vm.getCombined(row),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }